import { render, staticRenderFns } from "./SpecifySignerDialog.vue?vue&type=template&id=4235997c"
import script from "./SpecifySignerDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpecifySignerDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpecifySignerDialog.vue?vue&type=style&index=0&id=4235997c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@7.1.2_@rspack+core@2.1.8_webpack_6b8fc1273ff717b8f145294df5db1f84/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports